/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, Input, OnDestroy, Optional} from '@angular/core';

import {LoadingListener} from './loading-listener';
export class Loading implements OnDestroy {
/**
 * @param {?} listener
 */
constructor(
private listener: LoadingListener) {}
private _loading = false;
/**
 * @return {?}
 */
public get loading() {
        return this._loading;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set loading(value: boolean) {
        value = !!value;
        if (value === this._loading) {
            return;
        }
        this._loading = value;
        if (this.listener) {
            if (value) {
                this.listener.startLoading();
            } else {
                this.listener.doneLoading();
            }
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.loading = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrLoading]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoadingListener, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'loading': [{ type: Input, args: ["clrLoading", ] },],
};
}

function Loading_tsickle_Closure_declarations() {
/** @type {?} */
Loading.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Loading.ctorParameters;
/** @type {?} */
Loading.propDecorators;
/** @type {?} */
Loading.prototype._loading;
/** @type {?} */
Loading.prototype.listener;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
